import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class DwellingInspectionKey extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.keyTypeId = model.keyTypeId;
      this.quantity = model.quantity;
      this.quantityLentOut = model.quantityLentOut;
      this.systemNumber = model.systemNumber;
      this.marking = model.marking;
      this.returnedQuantity = model.returnedQuantity;
      this.chargedAmount = model.chargedAmount;
      this.dwellingInspectionId = model.dwellingInspectionId;
      this.supplier = model.supplier;
      this.caption = model.caption;
      this.key = model.key;
    }
  }

  keyTypeId: string;
  dwellingInspectionId: string;
  quantity: number;
  quantityLentOut: number;
  returnedQuantity: number;
  systemNumber: string;
  marking: string;
  chargedAmount: Money;
  supplier: string;
  caption: string;
  key: string;
}
